const muiTheme = {
  typography: {
    useNextVariants: true
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          paddingTop: 14
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        body: {
          fontSize: 16
        },
        head: {
          fontSize: 16
        }
      }
    },
    MuiTablePagination: {
      styleOverrides: {
        caption: {
          fontSize: 14
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          paddingTop: 5,
          paddingBottom: 5
        },
        label: {
          fontSize: 14
        }
      }
    },
    MuiTabs: {
      defaultProps: {
        textColor: 'contrastText',
        indicatorColor: 'secondary',
        centered: true
      }
    },
    MuiTab: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          textTransform: 'none',
          minWidth: 160,
          fontSize: theme.typography.pxToRem(18),
          opacity: (ownerState.selected) ? 1 : 0.7
        }),
      }
    }
  },
  mixins: {},
  palette: {
    text: {
      contrastText: '#f50057'
    },
    mode: 'light',
    type: 'light'
  }
};

export { muiTheme };
